<script setup lang="ts">
import { mapState } from "../../context/context";
import IconWarn from "../icon/IconWarn.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { IconWarn },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    type?: "none" | "warn";
    text?: string;
    color?: string;
  }>(),
  {
    type: "none",
    text: ""
  }
);

const mappedState = mapState(["color.fontPattern"]);

defineExpose({});
</script>

<template>
  <div
    class="text"
    :style="{
      color: props.color || mappedState['color.fontPattern'].value
    }"
  >
    <div class="text-icon">
      <slot name="icon">
        <IconWarn v-if="props.type == 'warn'"></IconWarn>
      </slot>
    </div>
    <div
      class="ellipsis"
      :style="{ marginLeft: props.type == 'none' ? '0' : '0.35em' }"
    >
      <slot>{{ props.text }}</slot>
    </div>
  </div>
</template>

<style scoped>
.text {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 1em;
  line-height: 1;
  max-width: 100%;
}
.text .text-icon {
  flex: 0 0 auto;
  width: 1em;
}
</style>
